export const ru = {
    'error-refresh': 'Возникла ошибка. Попробуйте обновить страницу.'
};
